import React, { 
  useContext, useEffect, useRef, useState,
 } from 'react';
import PropTypes from 'prop-types';
import { GlobalVarContext } from '../../../../context/GlobalVarContext';

const ImageGalleryHorizontal = ({ parsedimages }) => {
  const { apiGlobal } = useContext(GlobalVarContext);
  const imgPath = `${apiGlobal}/images/meal/attachment/`;

  const scrollRef = useRef(null);
  const [scrollIndex, setScrollIndex] = useState(0);
  const imagesPerView = 10; // Number of images visible at a time
  const imageWidth = 220; // Width of each image + margin

  useEffect(() => {
    const interval = setInterval(() => {
      if (parsedimages.length > imagesPerView) {
        setScrollIndex(prevIndex => (prevIndex + 1 >= parsedimages.length ? 0 : prevIndex + 1));
      }
    }, 2000); // Change image every 2 seconds

    return () => clearInterval(interval);
  }, [parsedimages]);

  useEffect(() => {
    if (scrollRef.current) {
      const maxScroll = scrollRef.current.scrollWidth - scrollRef.current.clientWidth;
      let newScrollLeft = scrollRef.current.scrollLeft + imageWidth;

      if (newScrollLeft >= maxScroll) {
        newScrollLeft = 0; // Reset scroll position when max scroll is reached
      }

      scrollRef.current.scrollTo({
        left: newScrollLeft,
        behavior: 'smooth',
      });
    }
  }, [scrollIndex]);

  return (
    <div className="container mt-5">
      <div className="bg-white p-4 rounded shadow-lg">
        <h2 className="text-center mb-4">Image Gallery</h2>
        {parsedimages.length > 0 ? (
          <div className="scroll-container" ref={scrollRef}>
            {parsedimages.map(image => (
              <div key={image.logo_id} className="image-card">
                <img
                  src={imgPath + image.file_name}
                  alt={image.file_name || 'Gallery image'}
                  className="fixed-size-img"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center p-4">
            <p className="text-muted">No images available</p>
          </div>
        )}
      </div>

      <style jsx>{`
        .scroll-container {
          display: flex;
          overflow-x: auto;
          scroll-behavior: smooth;
          white-space: nowrap;
          width: 100%;
          max-width: 1300px;
          padding-bottom: 10px;
        }

        .scroll-container::-webkit-scrollbar {
          display: none;
        }

        .image-card {
          flex: 0 0 auto;
          width: 200px;
          margin-right: 20px;
        }

        .fixed-size-img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          border-radius: 8px;
        }
        `}
      </style>
    </div>
  );
};

ImageGalleryHorizontal.propTypes = {
  parsedimages: PropTypes.arrayOf(
    PropTypes.shape({
      logo_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      file_name: PropTypes.string.isRequired,
    }),
  ),
};

ImageGalleryHorizontal.defaultProps = {
  parsedimages: [],
};

export default ImageGalleryHorizontal;


// import React, { useContext } from 'react';
// import PropTypes from 'prop-types';
// import { GlobalVarContext } from '../../../../context/GlobalVarContext';

// const ImageGallery = ({ parsedimages }) => {
//   const { apiGlobal } = useContext(GlobalVarContext);
//   // Base URL for the image path
//   const imgPath = `${apiGlobal}/images/meal/attachment/`;

//   return (
//     <div className="container mt-4 px-4">
//       <div className="row g-4 justify-content-center">
//         {parsedimages && parsedimages.length > 0 ? (
//           parsedimages.map(image => (
//             <div 
//               key={image.logo_id} 
//               className="col-12 col-sm-6 col-md-4 col-lg-3"
//             >
//               <div className="relative group">
//                 <img
//                   src={imgPath + image.file_name}
//                   alt={image.file_name || 'Gallery image'}
//                   className="w-full h-64 object-cover rounded-lg 
//                   shadow-md transition-all duration-300 group-hover:shadow-xl"
//                   loading="lazy"
//                 />
//                 <div className="absolute inset-0 bg-black opacity-0 
//                 group-hover:opacity-10 transition-opacity duration-300 rounded-lg"
//                 />
//               </div>
//             </div>
//           ))
//         ) : (
//           <div className="col-12 py-8">
//             <div className="bg-gray-50 rounded-lg p-8 text-center shadow-sm">
//               <p className="text-gray-500 text-lg mb-0">No images available</p>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// ImageGallery.propTypes = {
//   parsedimages: PropTypes.arrayOf(
//     PropTypes.shape({
//       logo_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
//       file_name: PropTypes.string.isRequired,
//     }),
//   ),
// };

// ImageGallery.defaultProps = {
//   parsedimages: [],
// };

// export default ImageGallery;

